import React from "react";
import csc from "../assets/csc.png";
import { draCourseIds } from "../config";
import { getCourseIds } from "../utils/getCourseIds";
export default function BaseLayout({
  noIcon,
  children,
}: {
  readonly noIcon?: boolean;
  readonly children: any;
}) {
  const courseIds = getCourseIds();

  const isDRA = courseIds?.some((id) => draCourseIds.includes(id));
  return (
    <div className="flex items-center justify-center bg-img py-6 px-10">
      <div className="w-full p-8 bg-white rounded-lg flex justify-center max-w-[900px]">
        <div className="w-full">
          {!noIcon && (
            <div className="flex justify-between items-center w-full space-x-4 mt-4">
              {/* <img alt="" src={iibf} className="h-7 sm:h-10 md:h-12" /> */}
              <h6 className="iibf-logo">
                {courseIds == draCourseIds
                  ? "DRA Training Program"
                  : "BC Training Program"}
              </h6>
              {/* <img alt="" src={logo} className="h-7 sm:h-10 md:h-12" /> */}
              <img alt="" src={csc} className="h-7 sm:h-10 md:h-12" />
            </div>
          )}
          {!isDRA && (
            <div className="bg-[#feffd5] border border-yellow-400 text-yellow-900 px-6 py-4 rounded-md text-[12px] my-4 leading-tight flex flex-col gap-[6px]">
              <div className="font-bold text-[13px] text-center">
                Attention Candidates (Read Carefully): Individuals trained through CSC Academy in BC Advanced/ Basic Courses are restricted from taking exams at any CSC Center. Please select an alternative authorized exam center through IIBF Non-Member Portal.
              </div>
              <div className="text-left">
                <strong className="text-[14px]">Trained Before 26-Aug-2026 Register (BC & DRA):</strong> Open{" "}
                <a
                  className="text-indigo-800 text-[14px] font-bold hover:underline"
                  href="https://portal.iibf.org.in/bcbf/apply-exam"
                  target="_blank"
                  rel="noreferrer"
                >
                  portal.iibf.org.in/bcbf/apply-exam
                </a>
                , enter your training ID, & submit to get IIBF Non-Member Portal login credentials on registered email id. | <strong className="text-[14px]">Complete KYC</strong> - Do e-KYC via Aadhaar OTP if prompted, or proceed without KYC & start using the portal.
              </div>
              <div className="text-left">
                <strong className="text-[14px]">Examination (BC & DRA):</strong> BC Candidates can apply for the exam when the monthly window opens through IIBF Non-Member Portal, however DRA (Released/ Eligible) candidates exam applied by CSC Internally.
              </div>
              <div className="text-left">
                <strong className="text-[14px]">Trained After 26-Aug-2026:</strong> IIBF Non-Member Portal Credentials will be emailed automatically upon batch enrollment. Do not follow above registration steps. Just Log in and do your e-KYC if prompted & start using the portal.
              </div>
              <div className="text-left">
                <strong className="text-[14px]">IIBF Non-Member Issues:</strong> contact{" "}
                <a
                  className="text-indigo-800 font-bold hover:underline"
                  href="mailto:iibfwzmem@iibf.org.in"
                >
                  iibfwzmem@iibf.org.in
                </a>
                ,{" "}
                <a
                  className="text-indigo-800 font-bold hover:underline"
                  href="mailto:je.mss4@iibf.org.in"
                >
                  je.mss4@iibf.org.in
                </a>
                , or{" "}
                <a
                  className="text-indigo-800 font-bold hover:underline"
                  href="tel:08069260710"
                >
                  8069260710
                </a>{" "}
                | Do not register as an Ordinary Member on IIBF | Always use an active/correct email id and mobile number in CSC registration form.
              </div>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
